import React from 'react';
import { toast } from 'sonner';
import PaneSelector from './PaneSelector';
import LayoutCustomizer from './LayoutCustomizer';
import PresetLayoutSelector from './PresetLayoutSelector';
import KeyboardShortcutsHelp from '../KeyboardShortcutsHelp';

/**
 * Aggregates the four dialogs the dashboard owns. Keeps Dashboard.jsx
 * focused on layout/render concerns.
 */
const DashboardModals = ({
  // PaneSelector (mobile menu)
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  availablePanes,
  layout,
  onPaneSelect,
  onLogout,
  onOpenLayoutCustomizer,
  // LayoutCustomizer
  isLayoutCustomizerOpen,
  setIsLayoutCustomizerOpen,
  saveLayout,
  // Preset layouts
  isPresetLayoutSelectorOpen,
  setIsPresetLayoutSelectorOpen,
  saveLayoutGrid,
  language,
  // Keyboard shortcuts help
  isShortcutsHelpOpen,
  setIsShortcutsHelpOpen,
  shortcuts,
}) => (
  <>
    <PaneSelector
      isOpen={isMobileMenuOpen}
      onClose={() => setIsMobileMenuOpen(false)}
      availablePanes={availablePanes}
      currentLayout={layout}
      onPaneSelect={onPaneSelect}
      onLogout={onLogout}
      onOpenLayoutCustomizer={onOpenLayoutCustomizer}
    />
    <LayoutCustomizer
      isOpen={isLayoutCustomizerOpen}
      onClose={() => setIsLayoutCustomizerOpen(false)}
      availablePanes={availablePanes}
      currentLayout={layout}
      onLayoutSave={saveLayout}
    />
    <PresetLayoutSelector
      isOpen={isPresetLayoutSelectorOpen}
      onClose={() => setIsPresetLayoutSelectorOpen(false)}
      currentLayout={layout}
      onSelectPreset={(preset) => {
        // A preset can be either a flat array (legacy) or a 2D grid (new).
        if (Array.isArray(preset) && preset.every(Array.isArray)) {
          saveLayoutGrid(preset);
        } else {
          saveLayout(preset);
        }
        toast.success(language === 'es' ? 'Diseño aplicado' : 'Layout applied');
      }}
    />
    <KeyboardShortcutsHelp
      isOpen={isShortcutsHelpOpen}
      onClose={() => setIsShortcutsHelpOpen(false)}
      shortcuts={shortcuts}
    />
  </>
);

export default DashboardModals;
